import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateUserkeyword } from "store/actions/account";
import { makeStyles } from "@mui/styles";

import { KioskListToolbar, KioskTable } from "./components";

import CircularProgress from "@mui/material/CircularProgress";
import { Alert } from "@mui/material";

import { getAllKiosks } from "apis/devicesAPIs";
import { useQuery } from "@tanstack/react-query";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  content: {
    marginTop: theme.spacing(2),
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
}));

const KioskList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // The search filter in the store is shared by all list pages, while the search
  // box starts empty; clear it so a search typed on another page doesn't hide rows.
  useEffect(() => {
    dispatch(updateUserkeyword(""));
  }, [dispatch]);

  const { isLoading, isError, data, error } = useQuery({
    queryKey: ["KioskList"],
    queryFn: getAllKiosks,
    refetchOnMount: "always",
  });

  if (isError) {
    return (
      <main className={classes.content}>
        <Alert severity="error">{`${error.message} `}</Alert>{" "}
      </main>
    );
  }

  if (isLoading === true) {
    return (
      <main className={classes.content}>
        {isLoading && (
          <CircularProgress size={150} className={classes.uiProgess} />
        )}
      </main>
    );
  } else {
    return (
      <div className={classes.root}>
        <KioskListToolbar />
        <div className={classes.content}>
          {data ? <KioskTable deviceList={data} /> : null}
        </div>
      </div>
    );
  }
};

export default KioskList;
